import { ArrowUpRight } from "lucide-react";
import { SERVICES, waLink } from "@/lib/site";
import { Eyebrow, Reveal } from "./ui";

const Tile = ({ s, i }) => {
  const big = i === 0;
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--sx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--sy", `${e.clientY - r.top}px`);
  };
  return (
    <Reveal delay={i * 0.08} className={`${s.span} h-full`}>
      <a
        href={waLink(`punimin: ${s.title.toLowerCase()}`)}
        target="_blank"
        rel="noopener noreferrer"
        onMouseMove={onMove}
        data-testid={`service-tile-${s.id}`}
        className={`bento-tile group relative block h-full overflow-hidden bg-[#16161A] ${big ? "min-h-[440px]" : "min-h-[340px]"}`}
      >
        <img src={s.img} alt={s.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0C] via-[#0B0B0C]/45 to-transparent" />
        <div className="absolute inset-0 bento-spot" />
        <div className="relative h-full flex flex-col justify-between p-6 sm:p-8">
          <div className="flex items-start justify-between">
            <span className="font-mono-x text-xs tracking-[0.3em] text-[#E3C88A] bg-black/50 backdrop-blur-md px-3 py-1.5 rounded-full">{s.kicker}</span>
            <span className="w-11 h-11 rounded-full border border-white/30 grid place-items-center text-white transition duration-500 group-hover:bg-[#C9A55C] group-hover:border-[#C9A55C] group-hover:text-[#0B0B0C] group-hover:rotate-45">
              <ArrowUpRight className="w-4 h-4" />
            </span>
          </div>
          <div>
            <h3 className={`font-display font-light text-[#F3EEE4] leading-none ${big ? "text-5xl sm:text-7xl" : "text-4xl sm:text-5xl"}`}>{s.title}</h3>
            <p className={`mt-4 text-[#DDD6C9] leading-relaxed ${big ? "max-w-md text-base" : "text-sm"}`}>{s.text}</p>
          </div>
        </div>
      </a>
    </Reveal>
  );
};

export const Lavorazioni = () => (
  <section id="lavorazioni" className="bg-[#0B0B0C] pb-24 sm:pb-36" data-testid="services-section">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
        <Reveal>
          <Eyebrow>Punime me porosi</Eyebrow>
          <h2 className="font-display font-light text-5xl sm:text-6xl lg:text-7xl text-[#F3EEE4] mt-6 leading-[1] max-w-3xl">
            Nga pllaka <em className="text-gold-grad">te shtëpia</em>.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-[#CFC8BA] max-w-sm text-base leading-relaxed">Përgatisim dhe montojmë mermer dhe granit për çdo ambient. Prekni një punim për të kërkuar ofertë.</p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-[340px_340px] gap-4 sm:gap-5" data-testid="services-bento">
        {SERVICES.map((s, i) => <Tile key={s.id} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
